
import Hero from './components/Hero';
import GalleryGrid from './components/GalleryGrid';

export default function GalleryPage() {
  return (
    <>
      <Hero />
      <GalleryGrid />
    </>
  );
}
